<template lang="pug">
el-dialog.dialog-customers(:visible='visible', :before-close='exit')
  h1.ui.header
    | {{room.no}}
    .sub.header 住户信息
  .ui.form: .ui.field
    form-customers(:customers='draft.customers', :cancelable='false', ref='customers')

  div(slot='footer')
    .ui.button.themed(@click='save') 保存
    .ui.button(@click='exit()') 取消
</template>

<script>
import FormCustomers from './FormCustomers.vue'

export default {
  name: 'dialog-customers',
  components: { FormCustomers },
  props: {
    contract: Object,
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      draft: {
        customers: [],
      },
    }
  },
  computed: {
    room() {
      if (this.contract)
        return this.$store.getters.room_by_id(this.contract._room)
      return {}
    },
    customers() {
      if (this.contract)
        return this.$store.getters.customers_filter(this.contract._customers)
      return []
    },
  },
  mounted() {
    this.init()
  },
  watch: {
    contract: {
      deep: true,
      handler() {
        this.init()
      },
    },
  },
  methods: {
    init() {
      this.draft.customers = this.customers
    },
    save() {
      this.$refs.customers.form_validate().then(() => {
        this.$http.put(`contracts/${this.contract._id}/customers`, { customers: this.draft.customers })
          .then(r => {
            const customers = r.body.data.customers
            this.exit(customers)
          })
          .catch(this.$utils.DefaultErrorHandler.bind(this))
      })
    },
    clear() {
      this.init()
    },
    exit(customers) {
      this.$emit('update:visible', false)
      this.$emit('exit', customers)
    },
  },
}
</script>



// WEBPACK FOOTER //
// DialogCustomers.vue?32d7605a